module.exports = "/assets/_next/static/images/clouds-left-b85acc1b6ae89695809a91420440641e.png";